// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import firebase from 'firebase'
import 'normalize.css'
import './assets/sass/style.scss'
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
// アイコンを読み込み
library.add(fas, far, fab);
// Vueコンポーネントを作成
Vue.component('v-fa', FontAwesomeIcon);

// import SocialSharing from 'vue-social-sharing'
// Vue.use(SocialSharing)

// import VueMeta from 'vue-meta'
// Vue.use(VueMeta, {
//   // optional pluginOptions
//   refreshOnceOnNavigation: true
// })

Vue.config.productionTip = false


const firebaseConfig = {
  apiKey: "AIzaSyB_aHFyXkC3ioPQV73eSYo3llQ2UpZbfBo",
  authDomain: "tweet-self-analysis.firebaseapp.com",
  databaseURL: "https://tweet-self-analysis.firebaseio.com",
  projectId: "tweet-self-analysis",
  storageBucket: "",
  messagingSenderId: "283172518627",
  appId: "1:283172518627:web:802edd02cb698565"
};
firebase.initializeApp(firebaseConfig);



/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js